module.exports = __webpack_public_path__ + "img/banner2.a88efeba.jpg";